var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"avatar":_vm.avatar,"name":_vm.name,"profile_url":_vm.profile_url,"prefix":_vm.prefix,"title":_vm.title,"doc":_vm.doc},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},[(!_vm.loading)?_c('router-view'):_vm._e(),_vm._t("content"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }